module.exports = __webpack_public_path__ + "static/media/dn-import.188af068.png";